import { useFilePreviewWithAlert } from "@shared";

import { DocumentResponse } from "@/api";
import { FileActions } from "@/common/components/layout/components/dropzone/DropZone.types";

interface UseDocumentPreviewParams {
  file: DocumentResponse;
  fileActions: FileActions;
  onPreviewOpen: () => void;
}

export function useDocumentPreview({ file, fileActions, onPreviewOpen }: UseDocumentPreviewParams) {
  const preview = useFilePreviewWithAlert({ fetchBlob: () => fileActions.onFetchPreviewBlob(file) });

  const handlePreview = () => {
    onPreviewOpen();
    preview.openPreview();
  };

  return {
    previewBlob: preview.previewBlob,
    isPreviewLoading: preview.isPreviewLoading,
    isPreviewOpen: preview.isPreviewOpen,
    closePreview: preview.closePreview,
    handlePreview,
  };
}
